import { Dispatch } from 'redux';
import { IReduxContext } from '../../store';
import { getVacanciesData } from '../vacancies';

import { IStore } from '../../../models/store';
import { IUser } from '../../../models/user';

import { getUserDataApi } from '../../../api/get_user';

export interface IUserDataAction {
  type: 'user/DATA_SUCCESS';
  user: IUser;
}

export const getUserData = (nodeApiHost: string) => {
  return (dispatch: Dispatch<any>, getState: () => IStore, context: IReduxContext) => {
      getUserDataApi(context.makeRequest, nodeApiHost)
        .then((user: IUser) => {
          dispatch({type: 'user/DATA_SUCCESS', user});

          const { isAuthenticated, isProfi } = user;

          if (isAuthenticated && isProfi) {
            dispatch(getVacanciesData());
          }
        });
    };
};

const initialState: IUser = {
  isAuthenticated: false,
};

export const userReducer = (state = initialState, action: IUserDataAction) => {
  switch (action.type) {
    case 'user/DATA_SUCCESS':
      return {
        ...action.user,
      };

    default:
      return state;
  }
};
